<ng-container *ngTemplateOutlet="container ? withContainerTemplate : noContainerTemplate"></ng-container>

<ng-template #withContainerTemplate>
  <div [ngClass]="containerClass">
    <ng-content></ng-content>
  </div>
</ng-template>

<ng-template #noContainerTemplate>
  <ng-content></ng-content>
</ng-template>
